import React from 'react';
import MobilePartnerLogo from './components/mlp-mobile-logos';
import CompareDrawer from '../compare/components/compare-drawer';
import withPage from '../page';
import MLP from './components';

const MLPContainer = () => {
    return (
        <>
            <MLP />
            <MobilePartnerLogo />
            <CompareDrawer />
        </>
    );
};

export default withPage(MLPContainer, {
    wrapperClassName: 'mdp-root',
    showWordCloud: true,
    useV2: true,
    useGraphQL: true,
});
